import { formatPhone, formatOsis, formatDate } from "../utils/format-utils";

export default class Client {
  clientId?: number;
  legacyClientId?: number | null;
  firstName?: string | null;
  middleInitial?: string | null;
  lastName?: string | null;
  osis?: string | null;
  gender?: string | null;
  dateOfBirth?: Date | null;
  streetAddress?: string | null;
  streetAddressLine2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  districtId?: number | null;
  homePhone?: string | null;
  mobilePhone?: string | null;
  workPhone?: string | null;
  emailAddress?: string | null;
  caregiverFirstName?: string | null;
  caregiverLastName?: string | null;
  caregiverRelationship?: string | null;

  public constructor(params: Client = {} as Client) {
    let {
      clientId = 0,
      legacyClientId = 0,
      firstName = "",
      middleInitial = "",
      lastName = "",
      osis = "",
      gender = "",
      dateOfBirth = null,
      streetAddress = "",
      streetAddressLine2 = "",
      city = "",
      state = "",
      zipCode = "",
      districtId = 0,
      homePhone = "",
      mobilePhone = "",
      workPhone = "",
      emailAddress = "",
      caregiverFirstName = "",
      caregiverLastName = "",
      caregiverRelationship = "",
    } = params;
    this.clientId = clientId;
    this.legacyClientId = legacyClientId;
    this.firstName = firstName;
    this.middleInitial = middleInitial;
    this.lastName = lastName;
    this.osis = osis && formatOsis(osis);
    this.gender = gender;
    this.dateOfBirth = dateOfBirth;
    this.streetAddress = streetAddress;
    this.streetAddressLine2 = streetAddressLine2;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.districtId = districtId;
    this.homePhone = homePhone && formatPhone(homePhone);
    this.mobilePhone = mobilePhone && formatPhone(mobilePhone);
    this.workPhone = workPhone && formatPhone(workPhone);
    this.emailAddress = emailAddress;
    this.caregiverFirstName = caregiverFirstName;
    this.caregiverLastName = caregiverLastName;
    this.caregiverRelationship = caregiverRelationship;
  }

  get name() {
    if (this.firstName && this.lastName)
      return this.firstName + " " + this.lastName;
  }

  get formattedDob() {
    return formatDate(this.dateOfBirth);
  }
}
